import Swal from "sweetalert2";
import SweetToast from "./SweetToast";

export function onFulfilled(response) {
  return response;
}

export function onRejected (error) {
  const { response } = error;
  const { status, data } = response;
  const { message } = data;

  if (status === 500){
    SweetToast.fire({
      icon: 'error',
      html: 'Whoops, something went wrong! Please try again later.',
    });
    return Promise.reject(error);
  }

  if (
    // TODO: Wider task needed around specifically handling unauth'd errors
    // Consider taking control of laravel's unauthenticated message
    // Ideally though, we want to avoid string comparison
    (
        status === 401 
        && message === 'Unauthenticated.'
    ) 
    || status === 419
  ) {
    Swal.fire({
      title: 'Session Timeout',
      html: 'Your session has timed out. Please refresh the page',
      icon: 'warning',
      confirmButtonText: 'Refresh',
      preConfirm() {
        location.reload();
      }
    });
    return;
  }

  return Promise.reject(error);
}
